export function initPopup() {
    var popup = document.querySelector('.popup') ?? null;
	if (popup) {
		var closeButton = document.querySelector('.popup__close');
		var background = document.querySelector('.popup__background');

		function handleScroll() {
			if (window.scrollY > 1200) { // Check if user has scrolled more than 600px
				showPopup();
				window.removeEventListener('scroll', handleScroll); // Remove the scroll event listener after showing the popup
			}
		}

		// Check if the popup cookie exists before showing the popup
		if (!popupCookieExists()) {
			window.addEventListener('scroll', handleScroll);
		}

		closeButton.addEventListener('click', function() {
			hidePopup();
			setPopupClosedCookie();
		});

		background.addEventListener('click', function() {
			hidePopup();
			setPopupClosedCookie();
		});

		function showPopup() {
			popup.classList.add('active');
			document.body.style.overflow = 'hidden'; // Disable scrolling when popup is open
		}

		function hidePopup() {
			popup.classList.remove('active');
			document.body.style.overflow = ''; // Enable scrolling when popup is closed
		}

		function setPopupClosedCookie() {
			var now = new Date();
			var time = now.getTime();
			var expireTime = time + 604800000; // 1 week
			now.setTime(expireTime);
			document.cookie = 'popupClosed=true;expires=' + now.toUTCString() + ';path=/';
		}

		function popupCookieExists() {
			return document.cookie.split(';').some((item) => item.trim().startsWith('popupClosed='));
		}
	}
}
